import classnames from 'classnames';
import { Selection, GlobalState } from '@leverege/ui-redux';
import { Dialogs } from '@leverege/ui-elements';
import { ContextMenu } from '@leverege/ui-plugin';
import { DataSources } from '@leverege/ui-attributes';
import { Plugins, Context } from '@leverege/plugin';
import S from './Shared.css';
const showPopup = (event, props) => {
  const position = {
    left: `${event.clientX}px`,
    top: `${event.clientY}px`
  };
  Dialogs.show({
    component: ContextMenu,
    props: {
      position,
      ...props,
      hideWhenEmpty: false
    }
  });
};
let timer;
let prevent = false;
const handleClick = (method, ...rest) => {
  timer = setTimeout(() => {
    if (!prevent) {
      method(...rest);
    }
    prevent = false;
  }, 200);
};
const handleDoubleClick = (method, ...rest) => {
  clearTimeout(timer);
  prevent = true;
  method(...rest);
};
const getRowProps = (props, {
  instance,
  row
}) => {
  const {
    context
  } = instance;
  const {
    clientProps: {
      rollover,
      selection,
      targeted,
      rolloverKey = 'rollover',
      selectionKey = 'selection',
      targetKey = 'targeted',
      actions
    }
  } = context;
  const {
    original: item
  } = row;
  const onClick = item => {
    GlobalState.dispatch(Selection.set(selectionKey, {
      id: item.id,
      type: item.type,
      ref: item.ref
    }));
  };
  const onDblClick = item => {
    // TODO: Navigate to detail page
    if (actions.isGotoAllowed()) {
      GlobalState.dispatch(actions.goTo(item.id));
    } else {
      const plgs = Plugins.get('tableDoubleClick', m => {
        return Context.isMatch({
          objectType: item?.type,
          client: 'GroupScreen',
          path
        }, m);
      });
      for (let n = 0; n < plgs.length; n++) {
        const callReturn = plgs[n].onClick(item, context);
        if (callReturn) {
          return;
        }
      }
    }
  };
  return {
    ...props,
    onClick: e => {
      handleClick(onClick, row?.original, e);
    },
    onDoubleClick: e => {
      handleDoubleClick(onDblClick, row?.original, e);
    },
    onMouseEnter: event => {
      GlobalState.dispatch(Selection.set(rolloverKey, {
        id: item.id,
        type: item.type,
        ref: item.ref
      }));
    },
    onMouseLeave: (event, item) => {
      GlobalState.dispatch(Selection.clear(rolloverKey));
    },
    onContextMenu: e => {
      e.preventDefault();
      let target;
      if (Selection.getIds(targeted).includes(item.id)) {
        target = targeted.items;
      } else {
        GlobalState.dispatch(Selection.set(targetKey, {
          id: item.id,
          type: item.type,
          ref: item.ref
        }));
        target = [item];
      }
      showPopup(e, {
        context: {
          ...context,
          target: DataSources.withData(target)
        },
        matchContext: {
          use: 'contextMenu',
          // client : 'GroupScreen',
          objectType: item.type
        }
      });
    },
    className: classnames(Selection.isSelected(rollover, row.id) && classnames(S.rollover, S.win, S.really), Selection.isSelected(selection, row.id) && classnames(S.selected, S.win, S.really), props.className)
  };
};
export default function useRowProps(hooks) {
  hooks.getRowProps.push(getRowProps);
}